// import {
//   Alert,
//   Box,
//   Button,
//   FormControl,
//   FormControlLabel,
//   InputLabel,
//   MenuItem,
//   Radio,
//   RadioGroup,
//   Select,
//   Snackbar,
//   TextField,
//   Typography,
// } from "@mui/material";
// import React, { useContext, useEffect, useState } from "react";
// import theme from "../../theme";
// import { AutoTaskAuthContext } from "../../Context/AutoTaskContext";
// import axios from "axios";
// import { useLocation, useNavigate } from "react-router-dom";
// import LoadingScreen from "../LoadingScreen";
// import { Tabs, Tab } from "@mui/material";

// // Icons
// import { ReactComponent as GoalIcon } from "../../assets/icons/goal.svg";
// import { ReactComponent as DeleteGoalIcon } from "../../assets/icons/delete-goal.svg";
// import PersonIcon from "@mui/icons-material/Person";
// import AddRoundedIcon from "@mui/icons-material/AddRounded";
// import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
// import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";
// import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
// import ApartmentRoundedIcon from "@mui/icons-material/ApartmentRounded";
// import PermIdentityRoundedIcon from "@mui/icons-material/PermIdentityRounded";
// import EngineeringRoundedIcon from "@mui/icons-material/EngineeringRounded";
// import HowToRegRoundedIcon from "@mui/icons-material/HowToRegRounded";
// import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
// import { Autocomplete } from "@mui/material";

// function UserMaster() {
//   const divisionOptions = [
//     "Engineering",
//     "Sales",
//     "Marketing",
//     "HR",
//     "Accounts",
//     "Order to Deilvery",
//     "R&D",
//     "Backoffice",
//   ];

//   const navigate = useNavigate();
//   const location = useLocation();
//   const editUserData = location?.state;
//   const user_id = editUserData?.staff_id || editUserData?.id;

//   const [editUserGoals, setEditUserGoals] = useState([]);
//   const [activeTab, setActiveTab] = useState(1);
//   const [staffList, setStaffList] = useState([]);
//   const [division, setDivision] = useState([]);

//   const contextData = useContext(AutoTaskAuthContext);
//   const userInfo = contextData?.userInfo;
//   const userStoreID = userInfo?.store_id;
//   const { store_id = null } = contextData?.userInfo;
//   const {
//     allKumuduDepartments,
//     allInternalDepartments,
//     availableRoles,
//     setReloadAppContext,
//   } = contextData;
//   const allDepartments =
//     store_id === 0 ? allKumuduDepartments : allInternalDepartments;
//   const allStaff =
//     allDepartments?.flatMap((dept) =>
//       (dept.staff || []).map((staffMember) => ({
//         ...staffMember,
//         dept_id: dept.dept_id,
//         dept_name: dept.dept_name,
//       })),
//     ) || [];
//   const [editUserDeptInfo, setEditUserDeptInfo] = useState(null);
//   // Scroll to top when component mounts or route changes
//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, []);

//   // useEffect(() => {
//   //   if (editUserData !== null) {
//   //     const foundDept = allDepartments.find((dept) =>
//   //       dept?.staff?.some((staff) => staff?.staff_id === editUserData.staff_id),
//   //     );
//   //     setEditUserDeptInfo(foundDept || null);
//   //   } else {
//   //     setEditUserDeptInfo(null);
//   //   }
//   // }, [editUserData]);

//   const fetchStaff = async () => {
//     const url = `${process.env.REACT_APP_API_BASE_URL}/api/ticket/performance/${userStoreID}`;

//     try {
//       const response = await axios.get(url);

//       let { statusCode, data } = response.data;
//       if (statusCode === 200 && Array.isArray(data)) {
//         setStaffList(
//           data.map((item) => ({
//             // ✅ transforms each item
//             staff_id: item.staff_id,
//             staff_name: item.staff_name,
//             staff_role: item.staff_role,
//             dept_name: item.department_name,
//             total_tickets: item.total_assigned_today || 0,
//             resolved_tickets: item.completed_today || 0,
//             rating: item.rating || 0,
//             staff_status: item.staff_status,
//             pending_ticket: item.pending_all_time,
//           })),
//         );
//       } else {
//         setSnackBarConfig({
//           open: true,
//           message: "Failed to fetch staff data",
//           severity: "error",
//         });
//       }
//     } catch (error) {
//       setSnackBarConfig({
//         open: true,
//         message: "Error fetching staff data",
//         severity: "error",
//       });
//     }
//   };

//   useEffect(() => {
//     const fetchStaffAndDivision = async () => {
//       const staffUrl = `${process.env.REACT_APP_API_BASE_URL}/api/ticket/performance/${userStoreID}`;
//       const divUrl = `${process.env.REACT_APP_API_BASE_URL}/api/auth/div/${store_id}`;

//       try {
//         // Run both requests concurrently
//         const results = await Promise.allSettled([
//           axios.get(divUrl),
//           axios.get(staffUrl),
//         ]);

//         // Handle division response
//         const divResult = results[0];
//         if (divResult.status === "fulfilled") {
//           const divData = divResult.value.data;
//           if (divData.statusCode === 200) {
//             setDivision(divData.data);
//           } else {
//             console.error("Failed to fetch division data", divData);
//           }
//         } else {
//           console.error("Division request failed:", divResult.reason);
//         }

//         // Handle staff response
//         const staffResult = results[1];
//         if (staffResult.status === "fulfilled") {
//           const staffRes = staffResult.value.data;
//           const { statusCode, data } = staffRes;

//           if (statusCode === 200 && Array.isArray(data)) {
//             setStaffList(
//               data.map((item) => ({
//                 staff_id: item.staff_id,
//                 staff_name: item.staff_name,
//                 staff_role: item.staff_role,
//                 dept_name: item.department_name,
//                 total_tickets: item.total_assigned_today || 0,
//                 resolved_tickets: item.completed_today || 0,
//                 rating: item.rating || 0,
//                 staff_status: item.staff_status,
//                 pending_ticket: item.pending_all_time,
//               })),
//             );
//           } else {
//             setSnackBarConfig({
//               open: true,
//               message: "Failed to fetch staff data",
//               severity: "error",
//             });
//           }
//         } else {
//           console.error("Staff request failed:", staffResult.reason);
//           setSnackBarConfig({
//             open: true,
//             message: "Error fetching staff data",
//             severity: "error",
//           });
//         }
//       } catch (error) {
//         console.error("Unexpected error:", error);
//         setSnackBarConfig({
//           open: true,
//           message: "Unexpected error occurred",
//           severity: "error",
//         });
//       }
//     };

//     fetchStaffAndDivision();
//   }, [userStoreID, store_id]);

//   const [userData, setUserData] = useState({
//     userName: editUserData !== null ? editUserData?.staff_name : null,
//     userMobile: editUserData !== null ? editUserData?.staff_mobile : null,
//     userEmail: editUserData !== null ? editUserData?.staff_email : null,
//     userAddress: editUserData !== null ? editUserData?.staff_address : null,
//     userDept: editUserData !== null ? editUserDeptInfo?.dept_id : null,
//     userRole: editUserData !== null ? editUserData?.staff_role : null,
//     userIsActive:
//       editUserData !== null
//         ? editUserData?.staff_status === "active"
//           ? "active"
//           : "inactive"
//         : "active",
//   });
//   // useEffect(() => {
//   //   if (editUserData) {
//   //     setUserData({
//   //       userName: editUserData?.staff_name || "",
//   //       userMobile: editUserData?.staff_mobile || "",
//   //       userEmail: editUserData?.staff_email || "",
//   //       userAddress: editUserData?.staff_address || "",
//   //       userDept: editUserDeptInfo?.dept_id || "",
//   //       userRole: editUserData?.staff_role || "",
//   //       userIsActive:
//   //         editUserData?.staff_status === "active"
//   //           ? "active"
//   //           : "inactive" || "active",
//   //     });
//   //   }
//   // }, [editUserData, editUserDeptInfo]);
//   useEffect(() => {
//     if (editUserData) {
//       setUserData({
//         userName: editUserData?.staff_name || "",
//         userMobile: editUserData?.staff_mobile || "",
//         userEmail: editUserData?.staff_email || "",
//         userAddress: editUserData?.staff_address || "",
//         userDept: editUserData?.dept_id || "", // ← directly from state
//         userRole: editUserData?.staff_role || "",
//         userIsActive:
//           editUserData?.staff_status === "active"
//             ? "active"
//             : "inactive" || "active",
//       });
//     }
//   }, [editUserData]);
//   const [goals, setGoals] = useState([{ task_name: "", target: "" }]);
//   const [loading, setLoading] = useState(false);
//   // Custom dialog box config
//   const [dialogConfig, setDialogConfig] = useState({
//     open: false,
//     message: "",
//     type: "success",
//   });
//   // Snackbar config
//   const [snackBarConfig, setSnackBarConfig] = useState({
//     open: false,
//     message: "",
//     severity: "",
//   });

//   // Close Snackbar
//   const handleClose = () =>
//     setSnackBarConfig((prevState) => ({ ...prevState, open: false }));

//   // Fetch tasks and targets
//   useEffect(() => {
//     const fetchLogs = async () => {
//       try {
//         const url = `${process.env.REACT_APP_API_BASE_URL}/api/ticket/tasks/${user_id}`;
//         const response = await axios.get(url);
//         const APIGoals = response?.data?.data;
//         setEditUserGoals([...APIGoals]);
//         APIGoals?.length === 0
//           ? setGoals((prevState) => [...prevState])
//           : setGoals(response.data.data);
//       } catch (error) {
//         console.error("Error fetching goals:", error);
//       }
//     };
//     if (user_id) fetchLogs();
//   }, [user_id]);

//   // Form fields changle handler
//   const handleChange = (targetField, targetValue) => {
//     if (targetField === "userMobile") {
//       if (!/^\d{0,10}$/.test(targetValue)) return;
//     }
//     setUserData((prevState) => ({ ...prevState, [targetField]: targetValue }));
//   };

//   // Goal fields change handler
//   const handleGoalFormChange = (index, field, value) => {
//     const updatedGoals = [...goals];
//     updatedGoals[index][field] = value;
//     setGoals(updatedGoals);
//   };

//   // Add new row to add goals form
//   const addGoalRow = () => {
//     // if (goals.length >= 5) {
//     //   setSnackBarConfig({
//     //     open: true,
//     //     message: "Maximum 5 goals can be set",
//     //     severity: "error",
//     //   });
//     //   return;
//     // }

//     // Check for any empty row
//     const hasEmptyRow = goals.some(
//       (goal) => goal.task_name.trim() === "" || goal.target === "",
//     );
//     if (hasEmptyRow) {
//       setSnackBarConfig({
//         open: true,
//         message: "Enter goal name and target",
//         severity: "error",
//       });
//       return;
//     }

//     // Check for duplicate goal names
//     const hasDuplicateGoal = () => {
//       const names = goals.map((goal) => goal.task_name.trim());
//       return new Set(names).size !== names.length; // true if duplicate exists
//     };
//     if (hasDuplicateGoal()) {
//       setSnackBarConfig({
//         open: true,
//         message: "Duplicate goal names are not allowed",
//         severity: "error",
//       });
//       return;
//     }

//     // Add new row iff no empty rows exist
//     setGoals([...goals, { task_name: "", target: "" }]);
//   };

//   // Remove row from add goals form
//   const removeGoalRow = (index) => {
//     if (goals.length === 1) {
//       setSnackBarConfig({
//         open: true,
//         message: "Set at least one goal",
//         severity: "error",
//       });
//       return;
//     }

//     setGoals((prevState) => prevState.filter((_, i) => i !== index));
//   };

//   // Validate fields while creating user
//   const validateFieldsWhileCreate = () => {
//     if (!userData.userName?.trim()) return "Name is required";
//     if (!userData.userMobile?.trim()) return "Mobile number is required";
//     allStaff?.some((staff) => {
//       if (userData.userMobile?.trim() === staff.staff_mobile?.trim())
//         return "User with this mobile already exists";
//     });
//     if (!userData.userEmail) return "Email is required";
//     if (!userData.userRole) return "Assign a role";

//     // Duplicate goal names check
//     if (goals.length > 0) {
//       const names = goals.map((goal) => goal.task_name?.trim()).filter(Boolean);
//       if (new Set(names).size !== names.length) {
//         return "Duplicate goal names are not allowed";
//       }
//     }

//     return null; // no error
//   };

//   // Validate fields while editing user
//   const validateFieldsWhileEdit = () => {
//     if (!userData.userName.trim()) return "Name is required";
//     if (!userData.userEmail) return "Email is required";
//     if (!userData.userDept) return "Assign a department";
//     if (!userData.userRole) return "Assign a role";

//     // Duplicate goal names check
//     if (goals.length > 0) {
//       const names = goals.map((goal) => goal.task_name.trim()).filter(Boolean);
//       if (new Set(names).size !== names.length) {
//         return "Duplicate goal names are not allowed";
//       }
//       if (
//         goals.some(
//           (goal) => goal?.task_name.trim() === "" || goal?.target === "",
//         )
//       ) {
//         return "Goal name or target can't be empty";
//       }
//     }

//     return null; // no error
//   };

//   // Create or Update user handler
//   const handleCreateOrUpdateUser = async () => {
//     // Create user
//     if (editUserData === null) {
//       const errorMessage = validateFieldsWhileCreate();
//       if (errorMessage) {
//         setSnackBarConfig({
//           open: true,
//           message: errorMessage,
//           severity: "error",
//         });
//         return;
//       }

//       const createUser_payload = {
//         name: userData?.userName,
//         mobile: userData?.userMobile,
//         email: userData?.userEmail,
//         address: userData?.userAddress,
//         role: userData?.userRole,
//         image: null, // Keep null as of now
//         dept_id: userData?.userDept,
//         store_id: store_id,
//         div_id: userData?.division?.div_id || null, // <-- added division id
//         div_name: userData?.division?.div_name || "", // <-- added division name
//       };
//       const createUser_URL = `${process.env.REACT_APP_API_BASE_URL}/api/auth/createuser`;

//       // Show loading overlay screen
//       setLoading(true);

//       try {
//         const createUser_res = await axios.post(
//           createUser_URL,
//           createUser_payload,
//         );
//         const user_id = createUser_res?.data?.data?.id;
//         if (!createUser_res?.data?.success) throw createUser_res?.data;

//         // Only call setGoals if goal form has atleast one goal
//         if (
//           goals.length >= 1 &&
//           goals.every((goal) => goal.task_name !== "" && goal.target !== "")
//         ) {
//           const setGoals_URL = `${process.env.REACT_APP_API_BASE_URL}/api/ticket/tasks`;

//           const setGoals_payload = goals?.map((goal) => ({
//             ...goal, // spread existing goal values
//             user_id: user_id, // attach user_id
//           }));

//           const updateGoals_res = await axios.post(
//             setGoals_URL,
//             setGoals_payload,
//           );
//           if (!updateGoals_res?.data?.success) throw updateGoals_res?.data;

//           setLoading(false);
//           // Show success message
//           setDialogConfig({
//             open: true,
//             message:
//               updateGoals_res?.data?.data?.statusMessage ||
//               "User with goals created successfully",
//             type: "success",
//           });

//           // Reset goals form
//           setGoals([{ task_name: "", target: "" }]);
//         } else {
//           setLoading(false);
//           // Show success message if no goals
//           setDialogConfig({
//             open: true,
//             message:
//               createUser_res?.data?.data?.statusMessage ||
//               "User created successfully",
//             type: "success",
//           });
//         }

//         // Refresh the context
//         setReloadAppContext((prevState) => !prevState);

//         // Reset user form
//         setUserData({
//           userName: "",
//           userMobile: "",
//           userEmail: "",
//           userAddress: "",
//           userRole: "",
//           userDept: "",
//         });
//       } catch (error) {
//         setLoading(false);
//         // Show error message
//         setDialogConfig({
//           open: true,
//           message:
//             error?.statusMessage ||
//             error?.response?.data?.statusMessage ||
//             "Failed to create user",
//           type: "error",
//         });
//       }
//     }

//     // Edit user
//     if (editUserData !== null) {
//       const errorMessage = validateFieldsWhileEdit();
//       if (errorMessage) {
//         setSnackBarConfig({
//           open: true,
//           message: errorMessage,
//           severity: "error",
//         });
//         return;
//       }

//       const editUser_payload = {
//         name: userData?.userName,
//         mobile: userData?.userMobile,
//         email: userData?.userEmail,
//         address: userData?.userAddress,
//         role: userData?.userRole,
//         image: null,
//         status: userData?.userIsActive,
//         dept_id: userData?.userDept,
//       };

//       const editUser_URL = `${process.env.REACT_APP_API_BASE_URL}/api/auth/updateuser/${user_id}`;

//       // Show loading overlay screen
//       setLoading(true);

//       try {
//         const editUser_res = await axios.put(editUser_URL, editUser_payload);
//         const user_id = editUser_res?.data?.data?.id;
//         if (!editUser_res?.data?.success) throw editUser_res?.data;

//         fetchStaff();

//         // Hit update goals API only if there is at least one edited goal
//         const shouldUpdateGoals = () => {
//           const filteredGoals = goals.filter(
//             (goal) => goal.task_name.trim() !== "" && goal.target !== "",
//           );

//           if (editUserGoals.length === 0) return filteredGoals.length > 0;

//           if (filteredGoals.length !== editUserGoals.length) return true;

//           // Compare by _id instead of index
//           return filteredGoals.some((goal) => {
//             const existing = editUserGoals.find((g) => g._id === goal._id);
//             if (!existing) return true; // New goal added
//             return (
//               goal.task_name !== existing.task_name ||
//               goal.target !== existing.target
//             );
//           });
//         };

//         if (shouldUpdateGoals()) {
//           const updateGoals_URL = `${process.env.REACT_APP_API_BASE_URL}/api/ticket/tasks`;

//           const updateGoals_payload = [];
//           goals?.forEach((goal, index) => {
//             if (
//               goal?.task_name === editUserGoals[index]?.task_name &&
//               goal?.target === editUserGoals[index]?.target
//             ) {
//               updateGoals_payload.push({
//                 ...goal,
//                 id: editUserGoals[index].task_id,
//                 user_id: user_id,
//               });
//             }
//             if (
//               goal?.task_name !== editUserGoals[index]?.task_name &&
//               goal?.target !== editUserGoals[index]?.target
//             ) {
//               updateGoals_payload.push({
//                 ...goal,
//                 user_id: user_id,
//               });
//             }
//           });

//           const updateGoals_res = await axios.put(
//             updateGoals_URL,
//             updateGoals_payload,
//           );
//           if (!updateGoals_res?.data?.success) throw updateGoals_res?.data;

//           setLoading(false);
//           // Show success message
//           setDialogConfig({
//             open: true,
//             message:
//               updateGoals_res?.data?.data?.statusMessage ||
//               "User with goals edited successfully",
//             type: "success",
//           });

//           // Reset goals form
//           setGoals([{ task_name: "", target: "" }]);
//         } else {
//           setLoading(false);
//           // Show success message if no goals updated
//           setDialogConfig({
//             open: true,
//             message:
//               editUser_res?.data?.data?.statusMessage ||
//               "User edited successfully",
//             type: "success",
//           });
//         }

//         // Refresh the context
//         setReloadAppContext((prevState) => !prevState);

//         // Reset user form
//         setUserData({
//           userName: "",
//           userMobile: "",
//           userEmail: "",
//           userAddress: "",
//           userRole: "",
//           userDept: "",
//         });

//         // Reset goals form
//         setGoals([{ task_name: "", target: "" }]);
//       } catch (error) {
//         setLoading(false);
//         // Show error message
//         setDialogConfig({
//           open: true,
//           message:
//             error?.statusMessage ||
//             error?.response?.data?.statusMessage ||
//             "Failed to edit user",
//           type: "error",
//         });
//       }
//     }
//   };
//   const handleEditStaff = (staff) => {
//     let selectedStaff = allStaff.find((st) => st.staff_id === staff.staff_id);
//     selectedStaff = { ...selectedStaff, staff_status: staff.staff_status };
//     setActiveTab(1);
//     navigate("/create-user", { state: selectedStaff });
//   };

//   const handleClear = () => {
//     setUserData({
//       userName: "",
//       userMobile: "",
//       userEmail: "",
//       userAddress: "",
//       userDept: "",
//       userRole: "",
//       userIsActive: "active",
//     });

//     setGoals([
//       {
//         goal_name: "",
//         goal_value: "",
//         goal_type: "",
//         start_date: "",
//         end_date: "",
//       },
//     ]);
//   };

//   return (
//     <>
//       {/* Loader Overlay */}
//       {loading && <LoadingScreen loadingMessage={"Processing User Data"} />}

//       {/* Create/Edit User & Goals Form and Create User Button Container */}
//       {/* Tabs for Existing / Create User */}
//       <Box
//         sx={{
//           width: "100%",
//           bgcolor: "white",
//           borderBottom: "1px solid #D4D4D4",
//           mb: 2,
//           display: "flex",
//           justifyContent: "center",
//         }}
//       >
//         <Tabs
//           value={activeTab}
//           onChange={(e, newValue) => setActiveTab(newValue)}
//           textColor="primary"
//           indicatorColor="primary"
//           aria-label="user tabs"
//         >
//           <Tab
//             label="Existing User"
//             sx={{
//               fontWeight: activeTab === 0 ? 600 : 400,
//               textTransform: "none",
//               fontSize: 16,
//             }}
//           />
//           <Tab
//             label="Create User"
//             sx={{
//               fontWeight: activeTab === 1 ? 600 : 400,
//               textTransform: "none",
//               fontSize: 16,
//             }}
//           />
//         </Tabs>
//       </Box>

//       {activeTab === 0 && (
//         <>
//           {/* Existing Users List */}
//           <Box
//             sx={{
//               width: "100%",
//               bgcolor: "#fff",
//               borderRadius: 2,
//               border: "1px solid #E0E0E0",
//               p: 2,
//             }}
//           >
//             <Typography sx={{ fontSize: 18, fontWeight: 600, mb: 2 }}>
//               Existing Users
//             </Typography>

//             {staffList && staffList.length > 0 ? (
//               <Box
//                 sx={{
//                   display: "flex",
//                   flexDirection: "column",
//                   gap: 1,
//                   maxHeight: "70vh",
//                   overflowY: "auto",
//                 }}
//               >
//                 {staffList.map((staff, index) => (
//                   <Box
//                     key={staff.staff_id || index}
//                     sx={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "center",
//                       border: "1px solid #E0E0E0",
//                       borderRadius: 2,
//                       px: 2,
//                       py: 1.5,
//                       boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
//                       "&:hover": {
//                         backgroundColor: "#f9f9f9",
//                       },
//                     }}
//                   >
//                     {/* Left - Name + Department */}
//                     <Box sx={{ display: "flex", flexDirection: "column" }}>
//                       <Typography sx={{ fontWeight: 600, fontSize: 14 }}>
//                         {staff.staff_name}
//                       </Typography>
//                       <Typography sx={{ fontSize: 12, color: "gray" }}>
//                         {staff.dept_name}
//                       </Typography>
//                     </Box>

//                     {/* Right Section - Status + Edit */}
//                     <Box
//                       sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 1.5,
//                       }}
//                     >
//                       {/* Status Chip */}
//                       <Box
//                         sx={{
//                           px: 1.5,
//                           py: 0.5,
//                           borderRadius: "20px",
//                           fontSize: 12,
//                           fontWeight: 600,
//                           textTransform: "capitalize",
//                           color:
//                             staff.staff_status === "active"
//                               ? "#2e7d32"
//                               : "#d32f2f",
//                           backgroundColor:
//                             staff.staff_status === "active"
//                               ? "rgba(46,125,50,0.1)"
//                               : "rgba(211,47,47,0.1)",
//                         }}
//                       >
//                         {staff.staff_status}
//                       </Box>

//                       {/* Edit Button */}
//                       <Button
//                         size="small"
//                         variant="outlined"
//                         sx={{
//                           textTransform: "none",
//                           borderRadius: 2,
//                           fontSize: 12,
//                           px: 1.5,
//                           py: 0.3,
//                           color: "#1c3891",
//                           borderColor: "#1c3891",
//                           "&:hover": {
//                             backgroundColor: "rgba(28,56,145,0.08)",
//                             borderColor: "#1c3891",
//                           },
//                         }}
//                         onClick={() => handleEditStaff(staff)}
//                         startIcon={
//                           <i
//                             className="fas fa-edit"
//                             style={{ fontSize: 12, color: "#1c3891" }}
//                           ></i>
//                         }
//                       >
//                         Edit
//                       </Button>
//                     </Box>
//                   </Box>
//                 ))}
//               </Box>
//             ) : (
//               <Typography
//                 sx={{ fontSize: 14, color: "gray", textAlign: "center" }}
//               >
//                 No users found.
//               </Typography>
//             )}
//           </Box>
//         </>
//       )}

//       {activeTab === 1 && (
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             flexDirection: "column",
//             width: "100%",

//             mt: 1,
//             mb: 5,
//           }}
//         >
//           {/* Create/Edit User Form */}
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: "column",
//               gap: 2,
//               width: "100%",
//               p: 1.25,

//               mb: 1,
//               bgcolor: "white",
//               border: "1px solid #D4D4D4",
//               borderRadius: 2,
//             }}
//           >
//             {/* Name */}
//             <TextField
//               InputLabelProps={{ shrink: true }}
//               label={
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//                   <PermIdentityRoundedIcon
//                     sx={{ fontSize: 20, fill: "#008080" }}
//                   />
//                   <Typography sx={{ fontSize: 16, color: "black" }}>
//                     Name
//                     {!userData.userName && (
//                       <span style={{ color: "red", marginLeft: 2 }}>*</span>
//                     )}
//                   </Typography>
//                 </Box>
//               }
//               fullWidth
//               value={userData.userName}
//               onChange={(e) => handleChange("userName", e.target.value)}
//               sx={formStyle}
//             />

//             {/* Mobile */}
//             <TextField
//               label={
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//                   <PhoneRoundedIcon sx={{ fontSize: 20, fill: "#008080" }} />
//                   <Typography sx={{ fontSize: 16, color: "black" }}>
//                     Mobile
//                     {!userData.userMobile && (
//                       <span style={{ color: "red", marginLeft: 2 }}>*</span>
//                     )}
//                   </Typography>
//                 </Box>
//               }
//               fullWidth
//               value={userData.userMobile}
//               onChange={(e) => {
//                 const digitsOnly = e.target.value.replace(/\D/g, "").slice(-10);
//                 handleChange("userMobile", digitsOnly);
//               }}
//               onPaste={(e) => {
//                 e.preventDefault();
//                 let pasted = (e.clipboardData || window.clipboardData).getData(
//                   "text",
//                 );

//                 pasted = pasted.replace(/\D/g, "");

//                 if (pasted.length > 10) {
//                   pasted = pasted.slice(-10);
//                 }

//                 handleChange("userMobile", pasted);
//               }}
//               inputProps={{
//                 maxLength: 10,
//                 inputMode: "numeric",
//                 pattern: "[0-9]*",
//               }}
//               InputLabelProps={{
//                 shrink: Boolean(userData.userMobile), // 👈 keeps label up when there's a value
//               }}
//               sx={formStyle}
//             />

//             {/* Email */}
//             <TextField
//               InputLabelProps={{ shrink: true }}
//               label={
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//                   <EmailRoundedIcon sx={{ fontSize: 20, fill: "#008080" }} />
//                   <Typography sx={{ fontSize: 16, color: "black" }}>
//                     E-mail
//                     {!userData.userEmail && (
//                       <span style={{ color: "red", marginLeft: 2 }}>*</span>
//                     )}
//                   </Typography>
//                 </Box>
//               }
//               fullWidth
//               value={userData.userEmail}
//               onChange={(e) => handleChange("userEmail", e.target.value)}
//               sx={formStyle}
//             />

//             {/* Department Dropdown */}
//             <FormControl fullWidth sx={formStyle}>
//               <InputLabel
//                 id="dept-id"
//                 sx={{ display: "flex", alignItems: "center", gap: 1.5 }}
//               >
//                 <ApartmentRoundedIcon sx={{ fontSize: 20, fill: "#008080" }} />
//                 <Typography sx={{ fontSize: 16, color: "black" }}>
//                   Department
//                 </Typography>
//               </InputLabel>
//               <Select
//                 labelId="dept-id"
//                 id="dept-id"
//                 value={userData.userDept || ""}
//                 label="Select Department"
//                 onChange={(e) => handleChange("userDept", e.target.value)}
//               >
//                 {allDepartments?.map((dept) => (
//                   <MenuItem key={dept.dept_id} value={dept.dept_id}>
//                     {dept.dept_name}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             {/* Role Dropdown */}
//             <FormControl fullWidth sx={formStyle}>
//               <InputLabel
//                 shrink
//                 id="role-id"
//                 sx={{ display: "flex", alignItems: "center", gap: 1.5 }}
//               >
//                 <EngineeringRoundedIcon
//                   sx={{ fontSize: 20, fill: "#008080" }}
//                 />
//                 <Typography sx={{ fontSize: 16, color: "black" }}>
//                   Role
//                   {!userData.userRole && (
//                     <span style={{ color: "red", marginLeft: 2 }}>*</span>
//                   )}
//                 </Typography>
//               </InputLabel>
//               <Select
//                 InputLabelProps={{ shrink: true }}
//                 labelId="role-id"
//                 id="role-id"
//                 value={userData.userRole}
//                 label="Select Role"
//                 onChange={(e) => handleChange("userRole", e.target.value)}
//               >
//                 {Object.entries(availableRoles).map(([key, label]) => (
//                   <MenuItem key={key} value={key}>
//                     {label}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             {/* Address */}
//             <TextField
//               InputLabelProps={{ shrink: true }}
//               label={
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//                   <HomeRoundedIcon sx={{ fontSize: 20, fill: "#008080" }} />
//                   <Typography sx={{ fontSize: 16, color: "black" }}>
//                     Address
//                   </Typography>
//                 </Box>
//               }
//               fullWidth
//               value={userData.userAddress}
//               onChange={(e) => handleChange("userAddress", e.target.value)}
//               sx={formStyle}
//               multiline
//               minRows={3}
//               maxRows={6}
//             />

//             {/* Status (Active / Inactive) */}
//             {editUserData !== null && (
//               <FormControl component="fieldset">
//                 <RadioGroup
//                   row
//                   name="userStatus"
//                   value={userData.userIsActive}
//                   onChange={(e) =>
//                     setUserData((prev) => ({
//                       ...prev,
//                       userIsActive: e.target.value,
//                     }))
//                   }
//                 >
//                   <FormControlLabel
//                     value="active"
//                     control={
//                       <Radio
//                         sx={{
//                           color: "#008046",
//                           "&.Mui-checked": {
//                             color: "#008046",
//                           },
//                         }}
//                       />
//                     }
//                     label="Active"
//                     sx={{
//                       color:
//                         userData.userIsActive === "active"
//                           ? "#008046"
//                           : "black",
//                       fontWeight:
//                         userData.userIsActive === "active" ? 600 : 400,
//                     }}
//                   />

//                   <FormControlLabel
//                     value="inactive"
//                     control={
//                       <Radio
//                         sx={{
//                           color: "#FF474A",
//                           "&.Mui-checked": {
//                             color: "#FF474A",
//                           },
//                         }}
//                       />
//                     }
//                     label="Inactive"
//                     sx={{
//                       color:
//                         userData.userIsActive === "inactive"
//                           ? "#FF474A"
//                           : "black",
//                       fontWeight:
//                         userData.userIsActive === "inactive" ? 600 : 400,
//                     }}
//                   />
//                 </RadioGroup>
//               </FormControl>
//             )}
//           </Box>

//           {/* Goals Form */}
//           <form
//             onSubmit={handleCreateOrUpdateUser}
//             style={{ width: "100%", marginBottom: "1.5rem" }}
//           >
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "flex-start",
//                 width: "100%",
//                 flexDirection: "column",
//                 gap: 1.25,

//                 bgcolor: "#FFE6EE",
//                 border: "1px solid #FFB8D1",
//                 borderRadius: 2,
//                 p: 1,
//               }}
//             >
//               {/* Heading */}
//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "flex-start",
//                   gap: 1.25,
//                 }}
//               >
//                 <GoalIcon />
//                 <Typography sx={{ fontSize: 18 }}>Set Goals</Typography>
//               </Box>

//               {/* Goal Rows Container */}
//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "flex-start",
//                   width: "100%",
//                   flexDirection: "column",
//                   gap: 0.5,
//                 }}
//               >
//                 {goals?.map((goal, index) => (
//                   <Box
//                     key={index}
//                     sx={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 0.5,
//                       width: "100%",
//                     }}
//                   >
//                     {/* Task Name */}
//                     <Box sx={{ bgcolor: "white", borderRadius: 2, flex: 3 }}>
//                       <TextField
//                         fullWidth
//                         placeholder="Goal name"
//                         variant="outlined"
//                         value={goal.task_name}
//                         onChange={(e) =>
//                           handleGoalFormChange(
//                             index,
//                             "task_name",
//                             e.target.value,
//                           )
//                         }
//                         multiline
//                         minRows={1}
//                         maxRows={4}
//                         sx={formStyle}
//                       />
//                     </Box>

//                     {/* Target */}
//                     <Box sx={{ bgcolor: "white", borderRadius: 2, flex: 1 }}>
//                       <TextField
//                         fullWidth
//                         type="number"
//                         placeholder="Target"
//                         variant="outlined"
//                         value={goal.target}
//                         onChange={(e) =>
//                           handleGoalFormChange(index, "target", e.target.value)
//                         }
//                         inputProps={{ min: 1 }}
//                         sx={formStyle}
//                       />
//                     </Box>

//                     {/* Type */}
//                     <Box sx={{ bgcolor: "white", borderRadius: 2, flex: 1 }}>
//                       <TextField
//                         select
//                         fullWidth
//                         variant="outlined"
//                         value={goal.task_type || ""} // ✅ FIX
//                         onChange={
//                           (e) =>
//                             handleGoalFormChange(
//                               index,
//                               "task_type",
//                               e.target.value,
//                             ) // ✅ FIX
//                         }
//                         sx={formStyle}
//                       >
//                         <MenuItem value="Daily">Daily</MenuItem>
//                         <MenuItem value="Weekly">Weekly</MenuItem>
//                         <MenuItem value="Sprint">Sprint</MenuItem>
//                         <MenuItem value="Inactive">Inactive</MenuItem>
//                       </TextField>
//                     </Box>

//                     {/* Department */}
//                     <Box sx={{ bgcolor: "white", borderRadius: 2, flex: 2 }}>
//                       <Autocomplete
//                         freeSolo
//                         options={division.map((d) => ({
//                           div_id: d.div_id,
//                           div_name: d.div_name,
//                         }))}
//                         getOptionLabel={(option) => option.div_name || ""}
//                         value={
//                           goal.division
//                             ? {
//                                 div_id: goal.division.div_id,
//                                 div_name: goal.division.div_name,
//                               }
//                             : null
//                         }
//                         onChange={(event, newValue) =>
//                           handleGoalFormChange(index, "division", newValue)
//                         }
//                         onInputChange={(event, newInputValue) =>
//                           handleGoalFormChange(index, "division", {
//                             div_id: null,
//                             div_name: newInputValue,
//                           })
//                         }
//                         renderInput={(params) => (
//                           <TextField
//                             {...params}
//                             placeholder="Division"
//                             variant="outlined"
//                             fullWidth
//                             sx={formStyle}
//                           />
//                         )}
//                       />
//                     </Box>

//                     {/* Remove */}
//                     <Box
//                       sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         border: `1px solid #D1D1D1`,
//                         bgcolor: "white",
//                         borderRadius: 2,
//                         flex: 0.5,
//                         height: 56,
//                         cursor: "pointer",
//                       }}
//                       onClick={() => removeGoalRow(index)}
//                     >
//                       <DeleteGoalIcon style={{ width: "100%", height: 30 }} />
//                     </Box>
//                   </Box>
//                 ))}
//               </Box>

//               {/* Add Goal Row Button */}
//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   gap: 0.25,
//                   alignSelf: "flex-end",

//                   background:
//                     "linear-gradient(90deg, #FF474A 0%, #F7B733 100%)",
//                   color: "white",
//                   fontSize: 16,
//                   borderRadius: 7,
//                   px: 3,
//                   py: 1.25,
//                   cursor: "pointer",
//                 }}
//                 onClick={addGoalRow}
//               >
//                 <Typography sx={{ fontSize: 16 }}>Add</Typography>
//                 <AddRoundedIcon />
//               </Box>
//             </Box>
//           </form>

//           {/* Create/Edit User Button */}
//           <Box display="flex" justifyContent="flex-end" gap={2} mt={3}>
//             <Button variant="outlined" color="secondary" onClick={handleClear}>
//               Clear
//             </Button>
//             <Button
//               variant="contained"
//               color="primary"
//               onClick={handleCreateOrUpdateUser}
//             >
//               {editUserData ? "Update" : "Save"}
//             </Button>
//           </Box>
//         </Box>
//       )}

//       {/* Created/Edited User Custom Dialog Box */}
//       {dialogConfig.open && (
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             width: "100%",
//             height: "100%",
//             position: "fixed",
//             top: 0,
//             left: 0,
//             bgcolor: "rgba(0,0,0,0.5)",
//             backdropFilter: "blur(8px)",
//             zIndex: 999,
//           }}
//         >
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: 0.5,
//               px: 5,
//               py: 2.5,
//               bgcolor: "white",
//               borderRadius: 5,
//               width: "90%",
//               maxWidth: 300,
//               textAlign: "center",
//             }}
//           >
//             {/* Icon */}
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 border: "1px solid #fff",
//                 borderRadius: 100,
//                 boxShadow:
//                   dialogConfig.type === "success"
//                     ? "0px 0px 15px #D4F7D2"
//                     : "0px 0px 15px #F7D2D2",
//                 p: 1,
//                 mb: 1.5,
//               }}
//             >
//               {dialogConfig.type === "success" ? (
//                 <HowToRegRoundedIcon sx={{ fontSize: 42, fill: "#008046" }} />
//               ) : (
//                 <CloseRoundedIcon sx={{ fontSize: 42, fill: "#FF474A" }} />
//               )}
//             </Box>

//             {/* Message */}
//             <Typography sx={{ textAlign: "center", wordWrap: "break-word" }}>
//               {dialogConfig.message}
//             </Typography>

//             {/* Done Button */}
//             <Typography
//               sx={{
//                 bgcolor:
//                   dialogConfig.type === "success"
//                     ? theme.lightTheme.themeCol
//                     : "#FF474A",
//                 color: "#fff",
//                 px: 2,
//                 py: 0.75,
//                 borderRadius: 3,
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 mt: 1,
//                 cursor: "pointer",
//                 textAlign: "center",
//                 width: "fit-content",
//                 minWidth: 80,
//               }}
//               onClick={() => {
//                 setDialogConfig((prev) => ({ ...prev, open: false }));
//                 if (dialogConfig.type === "success") {
//                   setTimeout(() => navigate(-1), 300);
//                 }
//               }}
//             >
//               Done
//             </Typography>
//           </Box>
//         </Box>
//       )}

//       {/* Snackbar */}
//       <Snackbar
//         open={snackBarConfig.open}
//         autoHideDuration={3000}
//         onClose={handleClose}
//         anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//         sx={{
//           "&.MuiSnackbar-root": {
//             bottom: "56px !important", // force override snackbar position
//           },
//         }}
//       >
//         {/* You can use Alert for styled messages */}
//         <Alert
//           onClose={handleClose}
//           severity={snackBarConfig.severity}
//           variant="filled"
//         >
//           {snackBarConfig.message}
//         </Alert>
//       </Snackbar>
//     </>
//   );
// }

// const formStyle = {
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "8px",
//     "& fieldset, & .MuiOutlinedInput-notchedOutline": {
//       borderColor: "#D1D1D1",
//       borderRadius: "8px",
//     },
//     "&:hover fieldset, &:hover .MuiOutlinedInput-notchedOutline": {
//       borderColor: "#D1D1D1",
//     },
//     "&.Mui-focused fieldset, &.Mui-focused .MuiOutlinedInput-notchedOutline": {
//       borderColor: "#D1D1D1",
//     },
//   },
//   "& .MuiInputLabel-root.Mui-focused": {
//     color: "#D1D1D1",
//   },
// };

// export default UserMaster;
import {
  Alert,
  Box,
  Button,
  FormControl,
  FormHelperText,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import theme from "../../theme";
import { AutoTaskAuthContext } from "../../Context/AutoTaskContext";
import { isBranchPinned, isHead } from "../../utils/roles";
import { useSwitchableBranches } from "../BranchSwitcher";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingScreen from "../LoadingScreen";
import { Tabs, Tab, Collapse } from "@mui/material";

// Icons
import { ReactComponent as GoalIcon } from "../../assets/icons/goal.svg";
import { ReactComponent as DeleteGoalIcon } from "../../assets/icons/delete-goal.svg";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import PermIdentityRoundedIcon from "@mui/icons-material/PermIdentityRounded";
import EngineeringRoundedIcon from "@mui/icons-material/EngineeringRounded";
import HowToRegRoundedIcon from "@mui/icons-material/HowToRegRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { Autocomplete } from "@mui/material";

// Yes/No feature component
import YesNoQuestionsManager from "./YesNoQuestionsManager"; // adjust path if needed

/* ── User directory card helpers ───────────────────────────────────────────
   A wall of avatars is the loudest thing on the screen, so the tints are
   desaturated and paired with their own darker ink instead of the saturated
   gradients used on the Performance directory. Same tone for the same name
   every render — it reads as identity, not decoration.                     */
const AVATAR_TONES = [
  { bg: "#EEF2FB", fg: "#2F4C8B" },
  { bg: "#EAF4F1", fg: "#2C6B5C" },
  { bg: "#F5F0EA", fg: "#83593A" },
  { bg: "#F1F0F7", fg: "#544E7C" },
  { bg: "#EDF3F7", fg: "#39607A" },
  { bg: "#F4F2E8", fg: "#6B6042" },
];

const getStaffInitials = (name) => {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return "?";
  const first = parts[0].charAt(0);
  const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : "";
  return (first + last).toUpperCase();
};

const getAvatarTone = (name) => {
  const key = String(name || "");
  let sum = 0;
  for (let i = 0; i < key.length; i += 1) sum += key.charCodeAt(i);
  return AVATAR_TONES[sum % AVATAR_TONES.length];
};

/* ── Shared chrome for both tabs ───────────────────────────────────────────
   One segmented-control style serves the directory's status filter and the
   form's status switch, so the two tabs read as one screen.               */
const segmentedTrackSx = {
  bgcolor: "#F4F5F8",
  border: "1px solid #EDEDF0",
  borderRadius: 999,
  p: "3px",
  "& .MuiToggleButtonGroup-grouped": {
    border: 0,
    borderRadius: "999px !important",
    textTransform: "none",
    fontSize: 13,
    fontWeight: 500,
    lineHeight: 1.6,
    px: 2,
    py: 0.35,
    color: "#6B7280",
    "&:hover": { backgroundColor: "transparent", color: "#1A1D24" },
    "&.Mui-selected": {
      color: "#1c3891",
      backgroundColor: "#fff",
      boxShadow: "0 1px 2px rgba(16,24,40,0.10)",
      "&:hover": { backgroundColor: "#fff" },
    },
  },
};

// Long department lists get a scrollable sheet instead of a menu taller than
// the viewport.
const selectMenuProps = {
  PaperProps: {
    sx: {
      maxHeight: 320,
      borderRadius: 2,
      mt: 0.5,
      boxShadow: "0 8px 24px rgba(16,24,40,0.12)",
    },
  },
};

// A titled group of fields. The form is a handful of these rather than one
// long ribbon of inputs, so a person can find "where do I set their role"
// without reading every field on the way down.
//
// `collapsible` turns the header into a toggle (driven by `expanded` /
// `onToggle`) and folds the body away. The action stays clickable in the
// header without toggling the card.
const SectionCard = ({
  icon,
  title,
  hint,
  action,
  children,
  sx,
  collapsible = false,
  expanded = true,
  onToggle,
}) => {
  const open = !collapsible || expanded;
  return (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      // A collapsible card spaces its body inside the Collapse instead, so a
      // folded card has no empty gap under the header.
      gap: collapsible ? 0 : { xs: 1.75, sm: 2 },
      p: { xs: 1.75, sm: 2.25 },
      bgcolor: "#fff",
      border: "1px solid #EDEDF0",
      borderRadius: 3,
      ...sx,
    }}
  >
    <Box
      {...(collapsible && {
        role: "button",
        tabIndex: 0,
        "aria-expanded": open,
        onClick: onToggle,
        onKeyDown: (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onToggle?.();
          }
        },
      })}
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 1.25,
        ...(collapsible && { cursor: "pointer", userSelect: "none" }),
      }}
    >
      {icon && (
        <Box
          aria-hidden="true"
          sx={{
            width: 34,
            height: 34,
            flexShrink: 0,
            borderRadius: 2,
            bgcolor: "#F4F5F8",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {icon}
        </Box>
      )}
      {/* minWidth keeps the heading legible; below that the action wraps to
          its own line instead of squeezing the hint into two words. */}
      <Box sx={{ minWidth: 170, flexGrow: 1 }}>
        <Typography sx={{ fontSize: 14.5, fontWeight: 600, color: "#1A1D24" }}>
          {title}
        </Typography>
        {hint && (
          <Typography sx={{ fontSize: 12, color: "#9AA0AC" }}>
            {hint}
          </Typography>
        )}
      </Box>
      {action && (
        // Clicking the action must not also fold/unfold the card.
        <Box
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
          sx={{ display: "contents" }}
        >
          {action}
        </Box>
      )}
      {collapsible && (
        <ExpandMoreRoundedIcon
          aria-hidden="true"
          sx={{
            flexShrink: 0,
            color: "#6B7280",
            transition: "transform 0.2s",
            transform: open ? "rotate(180deg)" : "none",
          }}
        />
      )}
    </Box>
    {collapsible ? (
      <Collapse in={open} unmountOnExit>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: { xs: 1.75, sm: 2 },
            pt: { xs: 1.75, sm: 2 },
          }}
        >
          {children}
        </Box>
      </Collapse>
    ) : (
      children
    )}
  </Box>
  );
};

// Two fields side by side on anything wider than a phone.
const fieldRowSx = {
  display: "grid",
  gridTemplateColumns: {
    xs: "minmax(0, 1fr)",
    sm: "repeat(2, minmax(0, 1fr))",
  },
  gap: { xs: 1.75, sm: 2 },
};

// One goal row on a wide screen: name, target, type, division, remove. The
// headings and the rows share it so the columns can never drift apart.
const goalGridColumns =
  "minmax(0, 3fr) minmax(0, 1.1fr) minmax(0, 1.3fr) minmax(0, 2fr) 40px";

const goalHeadingSx = {
  fontSize: 11,
  fontWeight: 600,
  letterSpacing: 0.4,
  textTransform: "uppercase",
  color: "#9AA0AC",
};

function UserMaster() {
  const divisionOptions = [
    "Engineering",
    "Sales",
    "Marketing",
    "HR",
    "Accounts",
    "Order to Deilvery",
    "R&D",
    "Backoffice",
  ];

  const navigate = useNavigate();
  const location = useLocation();
  const editUserData = location?.state;
  const user_id = editUserData?.staff_id || editUserData?.id;

  const [editUserGoals, setEditUserGoals] = useState([]);
  const [activeTab, setActiveTab] = useState(1);
  const [staffList, setStaffList] = useState([]);
  const [staffStatusFilter, setStaffStatusFilter] = useState("active");
  const [division, setDivision] = useState([]);
  // Inline form errors, keyed by the userData field they belong to.
  const [fieldErrors, setFieldErrors] = useState({});
  // Field wrappers, so a failed validation can focus what it complained about.
  const fieldRefs = useRef({});
  const registerField = (name) => (el) => {
    fieldRefs.current[name] = el;
  };

  // Existing Users list is shown one status at a time (toggle above the list)
  const filteredStaffList = (staffList || []).filter((staff) => {
    const isActive = String(staff?.staff_status).toLowerCase() === "active";
    return staffStatusFilter === "active" ? isActive : !isActive;
  });

  const contextData = useContext(AutoTaskAuthContext);
  const userInfo = contextData?.userInfo;
  const userStoreID = userInfo?.store_id;
  const { store_id = null } = contextData?.userInfo;
  const {
    allKumuduDepartments,
    allInternalDepartments,
    availableRoles,
    setReloadAppContext,
  } = contextData;
  const allDepartments =
    store_id === 0 ? allKumuduDepartments : allInternalDepartments;
  const allStaff =
    allDepartments?.flatMap((dept) =>
      (dept.staff || []).map((staffMember) => ({
        ...staffMember,
        dept_id: dept.dept_id,
        dept_name: dept.dept_name,
      }))
    ) || [];
  // Branches of the store these users belong to — the session's store, which
  // is the only store this screen creates into.
  const { branches: branchList } = useSwitchableBranches();

  // Compulsory only when creating. On an edit, blank means "keep the branch
  // they already have" and the payload leaves the field out entirely, so there
  // is nothing to insist on.
  const branchFieldRequired = editUserData === null;

  const [editUserDeptInfo, setEditUserDeptInfo] = useState(null);
  // Scroll to top when component mounts or route changes
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // useEffect(() => {
  //   if (editUserData !== null) {
  //     const foundDept = allDepartments.find((dept) =>
  //       dept?.staff?.some((staff) => staff?.staff_id === editUserData.staff_id),
  //     );
  //     setEditUserDeptInfo(foundDept || null);
  //   } else {
  //     setEditUserDeptInfo(null);
  //   }
  // }, [editUserData]);

  const fetchStaff = async () => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/api/ticket/performance/${userStoreID}`;

    try {
      const response = await axios.get(url);

      let { statusCode, data } = response.data;
      if (statusCode === 200 && Array.isArray(data)) {
        setStaffList(
          data.map((item) => ({
            // ✅ transforms each item
            staff_id: item.staff_id,
            staff_name: item.staff_name,
            staff_role: item.staff_role,
            dept_name: item.department_name,
            total_tickets: item.total_assigned_today || 0,
            resolved_tickets: item.completed_today || 0,
            rating: item.rating || 0,
            staff_status: item.staff_status,
            pending_ticket: item.pending_all_time,
          }))
        );
      } else {
        setSnackBarConfig({
          open: true,
          message: "Failed to fetch staff data",
          severity: "error",
        });
      }
    } catch (error) {
      setSnackBarConfig({
        open: true,
        message: "Error fetching staff data",
        severity: "error",
      });
    }
  };

  useEffect(() => {
    const fetchStaffAndDivision = async () => {
      const staffUrl = `${process.env.REACT_APP_API_BASE_URL}/api/ticket/performance/${userStoreID}`;
      const divUrl = `${process.env.REACT_APP_API_BASE_URL}/api/auth/div/${store_id}`;

      try {
        // Run both requests concurrently
        const results = await Promise.allSettled([
          axios.get(divUrl),
          axios.get(staffUrl),
        ]);

        // Handle division response
        const divResult = results[0];
        if (divResult.status === "fulfilled") {
          const divData = divResult.value.data;
          if (divData.statusCode === 200) {
            setDivision(divData.data);
          } else {
            console.error("Failed to fetch division data", divData);
          }
        } else {
          console.error("Division request failed:", divResult.reason);
        }

        // Handle staff response
        const staffResult = results[1];
        if (staffResult.status === "fulfilled") {
          const staffRes = staffResult.value.data;
          const { statusCode, data } = staffRes;

          if (statusCode === 200 && Array.isArray(data)) {
            setStaffList(
              data.map((item) => ({
                staff_id: item.staff_id,
                staff_name: item.staff_name,
                staff_role: item.staff_role,
                dept_name: item.department_name,
                total_tickets: item.total_assigned_today || 0,
                resolved_tickets: item.completed_today || 0,
                rating: item.rating || 0,
                staff_status: item.staff_status,
                pending_ticket: item.pending_all_time,
              }))
            );
          } else {
            setSnackBarConfig({
              open: true,
              message: "Failed to fetch staff data",
              severity: "error",
            });
          }
        } else {
          console.error("Staff request failed:", staffResult.reason);
          setSnackBarConfig({
            open: true,
            message: "Error fetching staff data",
            severity: "error",
          });
        }
      } catch (error) {
        console.error("Unexpected error:", error);
        setSnackBarConfig({
          open: true,
          message: "Unexpected error occurred",
          severity: "error",
        });
      }
    };

    fetchStaffAndDivision();
  }, [userStoreID, store_id]);

  const [userData, setUserData] = useState({
    userName: editUserData !== null ? editUserData?.staff_name : null,
    userMobile: editUserData !== null ? editUserData?.staff_mobile : null,
    userEmail: editUserData !== null ? editUserData?.staff_email : null,
    userAddress: editUserData !== null ? editUserData?.staff_address : null,
    userDept: editUserData !== null ? editUserDeptInfo?.dept_id : null,
    userRole: editUserData !== null ? editUserData?.staff_role : null,
    // The branch a pinned user is confined to. Prefilled from user-info's
    // branch_id (mapped in handleEditStaff). Still blank for an unpinned user,
    // and then the save omits it rather than guessing.
    userBranch:
      editUserData !== null ? editUserData?.staff_branch_id ?? "" : "",
    userIsActive:
      editUserData !== null
        ? editUserData?.staff_status === "active"
          ? "active"
          : "inactive"
        : "active",
  });
  // useEffect(() => {
  //   if (editUserData) {
  //     setUserData({
  //       userName: editUserData?.staff_name || "",
  //       userMobile: editUserData?.staff_mobile || "",
  //       userEmail: editUserData?.staff_email || "",
  //       userAddress: editUserData?.staff_address || "",
  //       userDept: editUserDeptInfo?.dept_id || "",
  //       userRole: editUserData?.staff_role || "",
  //       userIsActive:
  //         editUserData?.staff_status === "active"
  //           ? "active"
  //           : "inactive" || "active",
  //     });
  //   }
  // }, [editUserData, editUserDeptInfo]);
  useEffect(() => {
    if (editUserData) {
      setUserData({
        userName: editUserData?.staff_name || "",
        userMobile: editUserData?.staff_mobile || "",
        userEmail: editUserData?.staff_email || "",
        userAddress: editUserData?.staff_address || "",
        userDept: editUserData?.dept_id || "", // ← directly from state
        userRole: editUserData?.staff_role || "",
        userBranch: editUserData?.staff_branch_id ?? "",
        userIsActive:
          editUserData?.staff_status === "active"
            ? "active"
            : "inactive" || "active",
      });
    }
  }, [editUserData]);
  const [goals, setGoals] = useState([{ task_name: "", target: "" }]);
  // Goals card starts folded. It opens by itself only when the user being
  // edited already has saved goals; otherwise the head expands it by hand.
  const [goalsExpanded, setGoalsExpanded] = useState(false);
  const [loading, setLoading] = useState(false);
  // Custom dialog box config
  const [dialogConfig, setDialogConfig] = useState({
    open: false,
    message: "",
    type: "success",
  });
  // Snackbar config
  const [snackBarConfig, setSnackBarConfig] = useState({
    open: false,
    message: "",
    severity: "",
  });

  // Close Snackbar
  const handleClose = () =>
    setSnackBarConfig((prevState) => ({ ...prevState, open: false }));

  // Fetch tasks and targets
  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const url = `${process.env.REACT_APP_API_BASE_URL}/api/ticket/tasks/${user_id}`;
        const response = await axios.get(url);
        const APIGoals = response?.data?.data;
        setEditUserGoals([...APIGoals]);
        APIGoals?.length === 0
          ? setGoals((prevState) => [...prevState])
          : setGoals(response.data.data);
        setGoalsExpanded(APIGoals?.length > 0);
      } catch (error) {
        console.error("Error fetching goals:", error);
      }
    };
    // Fold again for every user opened, until their goals say otherwise.
    setGoalsExpanded(false);
    if (user_id) fetchLogs();
  }, [user_id]);

  // Form fields changle handler
  const handleChange = (targetField, targetValue) => {
    if (targetField === "userMobile") {
      if (!/^\d{0,10}$/.test(targetValue)) return;
    }
    // An error stops being true the moment the field is edited, so it clears
    // on the next keystroke instead of sitting there red while it is fixed.
    setFieldErrors((prev) =>
      prev[targetField] ? { ...prev, [targetField]: "" } : prev
    );
    setUserData((prevState) => ({ ...prevState, [targetField]: targetValue }));
  };

  // Puts the complaint on the field itself, focuses it and scrolls it into
  // view — a snackbar alone leaves the person hunting for which of a dozen
  // fields it meant.
  const reportValidationError = ({ field, message }) => {
    if (field) setFieldErrors({ [field]: message });
    setSnackBarConfig({ open: true, message, severity: "error" });
    const node = fieldRefs.current[field];
    if (!node) return;
    const focusable =
      node.querySelector?.(
        "input:not([type='hidden']), textarea, .MuiSelect-select"
      ) || node;
    focusable.focus?.({ preventScroll: true });
    node.scrollIntoView?.({ behavior: "smooth", block: "center" });
  };

  // Goal fields change handler
  const handleGoalFormChange = (index, field, value) => {
    const updatedGoals = [...goals];
    updatedGoals[index][field] = value;
    setGoals(updatedGoals);
  };

  // Add new row to add goals form
  const addGoalRow = () => {
    // if (goals.length >= 5) {
    //   setSnackBarConfig({
    //     open: true,
    //     message: "Maximum 5 goals can be set",
    //     severity: "error",
    //   });
    //   return;
    // }

    // Check for any empty row
    const hasEmptyRow = goals.some(
      (goal) => goal.task_name.trim() === "" || goal.target === ""
    );
    if (hasEmptyRow) {
      setSnackBarConfig({
        open: true,
        message: "Enter goal name and target",
        severity: "error",
      });
      return;
    }

    // Check for duplicate goal names
    const hasDuplicateGoal = () => {
      const names = goals.map((goal) => goal.task_name.trim());
      return new Set(names).size !== names.length; // true if duplicate exists
    };
    if (hasDuplicateGoal()) {
      setSnackBarConfig({
        open: true,
        message: "Duplicate goal names are not allowed",
        severity: "error",
      });
      return;
    }

    // Add new row iff no empty rows exist
    setGoals([...goals, { task_name: "", target: "" }]);
  };

  // Remove row from add goals form
  const removeGoalRow = (index) => {
    if (goals.length === 1) {
      setSnackBarConfig({
        open: true,
        message: "Set at least one goal",
        severity: "error",
      });
      return;
    }

    setGoals((prevState) => prevState.filter((_, i) => i !== index));
  };

  // Both validators return { field, message } so the offending field can be
  // outlined and focused, not just named in a snackbar.
  const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  // Validate fields while creating user
  const validateFieldsWhileCreate = () => {
    if (!userData.userName?.trim())
      return { field: "userName", message: "Name is required" };
    if (!userData.userMobile?.trim())
      return { field: "userMobile", message: "Mobile number is required" };
    if (userData.userMobile.trim().length !== 10)
      return {
        field: "userMobile",
        message: "A mobile number is 10 digits",
      };
    allStaff?.some((staff) => {
      if (userData.userMobile?.trim() === staff.staff_mobile?.trim())
        return "User with this mobile already exists";
    });
    if (!userData.userEmail)
      return { field: "userEmail", message: "Email is required" };
    if (!EMAIL_PATTERN.test(userData.userEmail.trim()))
      return { field: "userEmail", message: "Check this email address" };
    if (!userData.userRole)
      return { field: "userRole", message: "Assign a role" };
    // A Store HOD and Store Staff are confined to one branch, so somebody has
    // to say which. Asked rather than defaulted: without this the server picks
    // the main branch and every new person in a two-shop business silently
    // lands at the wrong counter.
    if (
      isBranchPinned(userData.userRole) &&
      branchList.length > 1 &&
      !userData.userBranch
    ) {
      return {
        field: "userBranch",
        message: "Choose the branch this person works at",
      };
    }

    // Duplicate goal names check
    if (goals.length > 0) {
      const names = goals.map((goal) => goal.task_name?.trim()).filter(Boolean);
      if (new Set(names).size !== names.length) {
        return {
          field: "goals",
          message: "Duplicate goal names are not allowed",
        };
      }
    }

    return null; // no error
  };

  // Validate fields while editing user
  const validateFieldsWhileEdit = () => {
    if (!userData.userName?.trim())
      return { field: "userName", message: "Name is required" };
    // Mobile is only checked when there is one — older records were created
    // without it and correcting an address shouldn't force a phone number.
    if (userData.userMobile?.trim() && userData.userMobile.trim().length !== 10)
      return { field: "userMobile", message: "A mobile number is 10 digits" };
    if (!userData.userEmail)
      return { field: "userEmail", message: "Email is required" };
    if (!EMAIL_PATTERN.test(userData.userEmail.trim()))
      return { field: "userEmail", message: "Check this email address" };
    if (!userData.userDept)
      return { field: "userDept", message: "Assign a department" };
    if (!userData.userRole)
      return { field: "userRole", message: "Assign a role" };

    // Duplicate goal names check
    if (goals.length > 0) {
      const names = goals.map((goal) => goal.task_name?.trim()).filter(Boolean);
      if (new Set(names).size !== names.length) {
        return {
          field: "goals",
          message: "Duplicate goal names are not allowed",
        };
      }
      if (
        goals.some((goal) => !goal?.task_name?.trim() || goal?.target === "")
      ) {
        return {
          field: "goals",
          message: "Goal name or target can't be empty",
        };
      }
    }

    return null; // no error
  };

  // Create or Update user handler
  const handleCreateOrUpdateUser = async (event) => {
    // The form submits on Enter now, and an unhandled submit would reload the
    // page and lose everything typed.
    event?.preventDefault?.();
    setFieldErrors({});

    // Create user
    if (editUserData === null) {
      const validationError = validateFieldsWhileCreate();
      if (validationError) {
        reportValidationError(validationError);
        return;
      }

      const createUser_payload = {
        name: userData?.userName,
        mobile: userData?.userMobile,
        email: userData?.userEmail,
        address: userData?.userAddress,
        role: userData?.userRole,
        image: null, // Keep null as of now
        dept_id: userData?.userDept,
        store_id: store_id,
        // Only ever sent for a role that is pinned to a branch; the server
        // writes null for everyone else regardless, and sending a stale value
        // from a role the form has since changed would just be noise.
        ...(isBranchPinned(userData?.userRole) && userData?.userBranch
          ? { branch_id: userData.userBranch }
          : {}),
        div_id: userData?.division?.div_id || null, // <-- added division id
        div_name: userData?.division?.div_name || "", // <-- added division name
      };
      const createUser_URL = `${process.env.REACT_APP_API_BASE_URL}/api/auth/createuser`;

      // Show loading overlay screen
      setLoading(true);

      try {
        const createUser_res = await axios.post(
          createUser_URL,
          createUser_payload
        );
        const user_id = createUser_res?.data?.data?.id;
        if (!createUser_res?.data?.success) throw createUser_res?.data;

        // Only call setGoals if goal form has atleast one goal
        if (
          goals.length >= 1 &&
          goals.every((goal) => goal.task_name !== "" && goal.target !== "")
        ) {
          const setGoals_URL = `${process.env.REACT_APP_API_BASE_URL}/api/ticket/tasks`;

          const setGoals_payload = goals?.map((goal) => ({
            ...goal, // spread existing goal values
            user_id: user_id, // attach user_id
          }));

          const updateGoals_res = await axios.post(
            setGoals_URL,
            setGoals_payload
          );
          if (!updateGoals_res?.data?.success) throw updateGoals_res?.data;

          setLoading(false);
          // Show success message
          setDialogConfig({
            open: true,
            message:
              updateGoals_res?.data?.data?.statusMessage ||
              "User with goals created successfully",
            type: "success",
          });

          // Reset goals form
          setGoals([{ task_name: "", target: "" }]);
        } else {
          setLoading(false);
          // Show success message if no goals
          setDialogConfig({
            open: true,
            message:
              createUser_res?.data?.data?.statusMessage ||
              "User created successfully",
            type: "success",
          });
        }

        // Refresh the context
        setReloadAppContext((prevState) => !prevState);

        // Reset user form
        setUserData({
          userName: "",
          userMobile: "",
          userEmail: "",
          userAddress: "",
          userRole: "",
          userDept: "",
        });
      } catch (error) {
        setLoading(false);
        // Show error message
        setDialogConfig({
          open: true,
          message:
            error?.statusMessage ||
            error?.response?.data?.statusMessage ||
            "Failed to create user",
          type: "error",
        });
      }
    }

    // Edit user
    if (editUserData !== null) {
      const validationError = validateFieldsWhileEdit();
      if (validationError) {
        reportValidationError(validationError);
        return;
      }

      const editUser_payload = {
        name: userData?.userName,
        mobile: userData?.userMobile,
        email: userData?.userEmail,
        address: userData?.userAddress,
        role: userData?.userRole,
        image: null,
        status: userData?.userIsActive,
        dept_id: userData?.userDept,
        // OMITTED, not blanked, when nothing was picked. The server treats an
        // absent branch_id as "leave their pin alone" and an empty one as
        // "work it out", which for a pinned role means the main branch — so
        // sending "" here would move every edited staff member to the main
        // branch the first time anyone corrected their phone number.
        ...(userData?.userBranch ? { branch_id: userData.userBranch } : {}),
      };

      const editUser_URL = `${process.env.REACT_APP_API_BASE_URL}/api/auth/updateuser/${user_id}`;

      // Show loading overlay screen
      setLoading(true);

      try {
        const editUser_res = await axios.put(editUser_URL, editUser_payload);
        const user_id = editUser_res?.data?.data?.id;
        if (!editUser_res?.data?.success) throw editUser_res?.data;

        fetchStaff();

        // Hit update goals API only if there is at least one edited goal
        const shouldUpdateGoals = () => {
          const filteredGoals = goals.filter(
            (goal) => goal.task_name.trim() !== "" && goal.target !== ""
          );

          if (editUserGoals.length === 0) return filteredGoals.length > 0;

          if (filteredGoals.length !== editUserGoals.length) return true;

          // Compare by _id instead of index
          return filteredGoals.some((goal) => {
            const existing = editUserGoals.find((g) => g._id === goal._id);
            if (!existing) return true; // New goal added
            return (
              goal.task_name !== existing.task_name ||
              goal.target !== existing.target
            );
          });
        };

        if (shouldUpdateGoals()) {
          const updateGoals_URL = `${process.env.REACT_APP_API_BASE_URL}/api/ticket/tasks`;

          const updateGoals_payload = [];
          goals?.forEach((goal, index) => {
            if (
              goal?.task_name === editUserGoals[index]?.task_name &&
              goal?.target === editUserGoals[index]?.target
            ) {
              updateGoals_payload.push({
                ...goal,
                id: editUserGoals[index].task_id,
                user_id: user_id,
              });
            }
            if (
              goal?.task_name !== editUserGoals[index]?.task_name &&
              goal?.target !== editUserGoals[index]?.target
            ) {
              updateGoals_payload.push({
                ...goal,
                user_id: user_id,
              });
            }
          });

          const updateGoals_res = await axios.put(
            updateGoals_URL,
            updateGoals_payload
          );
          if (!updateGoals_res?.data?.success) throw updateGoals_res?.data;

          setLoading(false);
          // Show success message
          setDialogConfig({
            open: true,
            message:
              updateGoals_res?.data?.data?.statusMessage ||
              "User with goals edited successfully",
            type: "success",
          });

          // Reset goals form
          setGoals([{ task_name: "", target: "" }]);
        } else {
          setLoading(false);
          // Show success message if no goals updated
          setDialogConfig({
            open: true,
            message:
              editUser_res?.data?.data?.statusMessage ||
              "User edited successfully",
            type: "success",
          });
        }

        // Refresh the context
        setReloadAppContext((prevState) => !prevState);

        // Reset user form
        setUserData({
          userName: "",
          userMobile: "",
          userEmail: "",
          userAddress: "",
          userRole: "",
          userDept: "",
        });

        // Reset goals form
        setGoals([{ task_name: "", target: "" }]);
      } catch (error) {
        setLoading(false);
        // Show error message
        setDialogConfig({
          open: true,
          message:
            error?.statusMessage ||
            error?.response?.data?.statusMessage ||
            "Failed to edit user",
          type: "error",
        });
      }
    }
  };

  const handleEditStaff = async (staff) => {
    if (isHead(userInfo.role)) {
      try {
        const baseURL = process.env.REACT_APP_API_BASE_URL;
        const response = await axios.get(`${baseURL}/api/auth/user-info`, {
          params: { user_id: staff.staff_id },
        });

        const { success, data } = response.data;

        if (success) {
          // Map API response to the shape your component expects
          const selectedStaff = {
            staff_id: data.id,
            staff_name: data.name,
            staff_mobile: data.mobile,
            staff_email: data.email,
            staff_address: data.address,
            staff_role: data.role,
            staff_status: data.status, // 'active' / 'inactive'
            dept_id: data.department?.id ?? null, // from associated department
            dept_name: data.department?.name ?? "",
            // The branch they are pinned to, so the Branch dropdown below
            // opens on it instead of blank.
            staff_branch_id: data.branch_id ?? "",
          };

          setActiveTab(1);
          navigate("/create-user", { state: selectedStaff });
        } else {
          console.error(
            "Failed to fetch user info:",
            response.data.statusMessage
          );
        }
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    }
  };

  const handleClear = () => {
    setUserData({
      userName: "",
      userMobile: "",
      userEmail: "",
      userAddress: "",
      userDept: "",
      userRole: "",
      userBranch: "",
      userIsActive: "active",
    });
    setFieldErrors({});

    // { task_name, target } — the shape every other reset and every reader in
    // this file uses. Clearing to { goal_name, goal_value, … } left a row
    // whose task_name was undefined, and the next "Add goal" threw on
    // goal.task_name.trim().
    setGoals([{ task_name: "", target: "" }]);
  };

  return (
    <>
      {/* Loader Overlay */}
      {loading && <LoadingScreen loadingMessage={"Processing User Data"} />}

      {/* Create/Edit User & Goals Form and Create User Button Container */}
      {/* Tabs for Existing / Create User */}
      <Box
        sx={{
          width: "100%",
          bgcolor: "white",
          borderBottom: "1px solid #D4D4D4",
          mb: 2,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          textColor="primary"
          indicatorColor="primary"
          aria-label="user tabs"
        >
          <Tab
            label="Existing Users"
            sx={{
              fontWeight: activeTab === 0 ? 600 : 400,
              textTransform: "none",
              fontSize: 16,
            }}
          />
          <Tab
            // The same tab is the edit form once a user is loaded into it, and
            // calling it "Create User" then is a small lie that makes people
            // hesitate before saving.
            label={editUserData ? "Edit User" : "Create User"}
            sx={{
              fontWeight: activeTab === 1 ? 600 : 400,
              textTransform: "none",
              fontSize: 16,
            }}
          />
        </Tabs>
      </Box>

      {activeTab === 0 && (
        <>
          {/* Existing Users Directory */}
          <Box
            sx={{
              width: "100%",
              bgcolor: "#fff",
              borderRadius: 3,
              border: "1px solid #EDEDF0",
              p: { xs: 1.5, sm: 2, md: 2.5 },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 1.5,
                mb: { xs: 1.25, sm: 1.75 },
              }}
            >
              {/* No heading here: the tab above already says which list this
                  is, and repeating it costs a line of vertical space that a
                  phone would rather spend on a card. The count is what the
                  heading was actually contributing. */}
              <Typography sx={{ fontSize: 13, color: "#9AA0AC" }}>
                {filteredStaffList.length}{" "}
                {staffStatusFilter === "active" ? "active" : "inactive"}
                {filteredStaffList.length === 1 ? " user" : " users"}
              </Typography>

              <ToggleButtonGroup
                exclusive
                size="small"
                value={staffStatusFilter}
                onChange={(e, newValue) => {
                  if (newValue) setStaffStatusFilter(newValue);
                }}
                sx={segmentedTrackSx}
              >
                <ToggleButton value="active">Active</ToggleButton>
                <ToggleButton value="inactive">Inactive</ToggleButton>
              </ToggleButtonGroup>
            </Box>

            {filteredStaffList.length > 0 ? (
              <Box
                sx={{
                  // The grid scrolls, not the page, so the tab bar stays put.
                  // Budget: App.js's main Box adds mt 56px always and mb 76px
                  // below md, and this page spends the rest on the tab bar,
                  // the panel padding and the header row above.
                  maxHeight: {
                    xs: "calc(100vh - 270px)",
                    md: "calc(100vh - 220px)",
                  },
                  minHeight: 160,
                  overflowY: "auto",
                  p: 0.5,
                  m: -0.5,
                  // No scrollbar chrome on a touch screen — the cut-off card
                  // at the edge already says there is more, and a phone has
                  // no pointer to grab a track with. The slim one stays from
                  // md up, where there is a mouse.
                  // md keeps "auto", not "thin": Chromium drops every
                  // ::-webkit-scrollbar rule the moment scrollbar-width has a
                  // non-initial value, which would trade the slim styled bar
                  // below for the browser's default one.
                  scrollbarWidth: { xs: "none", md: "auto" },
                  msOverflowStyle: "none",
                  "&::-webkit-scrollbar": {
                    width: { xs: 0, md: 6 },
                    display: { xs: "none", md: "block" },
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "transparent",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#E2E4EA",
                    borderRadius: 3,
                  },
                }}
              >
                <Box
                  sx={{
                    display: "grid",
                    // minmax(0, 1fr) — not 1fr — or a long name refuses to
                    // shrink and blows the track out instead of ellipsing.
                    gridTemplateColumns: {
                      xs: "minmax(0, 1fr)",
                      sm: "repeat(2, minmax(0, 1fr))",
                      lg: "repeat(3, minmax(0, 1fr))",
                    },
                    // MUI's xl starts at 1536, which leaves a 1440 laptop with
                    // 430px-wide cards and a lot of dead middle — so the 4th
                    // column comes in earlier than the breakpoint would give.
                    "@media (min-width:1400px)": {
                      gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
                    },
                    gap: { xs: 1.25, sm: 1.5 },
                  }}
                >
                  {filteredStaffList.map((staff, index) => {
                    const tone = getAvatarTone(staff.staff_name);
                    const roleLabel = availableRoles?.[staff.staff_role];

                    return (
                      <Box
                        key={staff.staff_id || index}
                        role="button"
                        tabIndex={0}
                        onClick={() => handleEditStaff(staff)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            handleEditStaff(staff);
                          }
                        }}
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1.25,
                          p: { xs: 1.5, sm: 1.75 },
                          borderRadius: 3,
                          border: "1px solid #EDEDF0",
                          bgcolor: "#fff",
                          cursor: "pointer",
                          transition:
                            "border-color .18s ease, box-shadow .18s ease, transform .18s ease",
                          "&:hover": {
                            borderColor: "#C9D3EA",
                            boxShadow: "0 6px 18px rgba(28,56,145,0.08)",
                            transform: "translateY(-2px)",
                          },
                          // Hover can't be relied on for touch, so the pencil
                          // is always legible and only firms up on hover.
                          "&:hover .user-card-edit, &:focus-within .user-card-edit":
                            {
                              opacity: 1,
                            },
                          "&:focus-visible": {
                            outline: "2px solid #1c3891",
                            outlineOffset: 2,
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5,
                            minWidth: 0,
                          }}
                        >
                          {/* Initials stand in for a photo */}
                          <Box
                            aria-hidden="true"
                            sx={{
                              width: 46,
                              height: 46,
                              flexShrink: 0,
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              bgcolor: tone.bg,
                              color: tone.fg,
                              fontSize: 15,
                              fontWeight: 600,
                              letterSpacing: 0.3,
                            }}
                          >
                            {getStaffInitials(staff.staff_name)}
                          </Box>

                          <Box sx={{ minWidth: 0, flexGrow: 1 }}>
                            <Typography
                              noWrap
                              title={staff.staff_name}
                              sx={{
                                fontSize: 14.5,
                                fontWeight: 600,
                                color: "#1A1D24",
                              }}
                            >
                              {staff.staff_name}
                            </Typography>
                            <Typography
                              noWrap
                              title={staff.dept_name || ""}
                              sx={{
                                fontSize: 12.5,
                                color: "#8A8F9A",
                                mt: 0.25,
                              }}
                            >
                              {staff.dept_name || "No department"}
                            </Typography>
                          </Box>

                          <Tooltip title="Edit user" arrow>
                            <IconButton
                              className="user-card-edit"
                              size="small"
                              aria-label={`Edit ${staff.staff_name}`}
                              onClick={(e) => {
                                // The whole card edits; don't let the button
                                // bubble up and fire handleEditStaff twice.
                                e.stopPropagation();
                                handleEditStaff(staff);
                              }}
                              sx={{
                                flexShrink: 0,
                                color: "#1c3891",
                                opacity: 0.55,
                                transition: "opacity .18s ease",
                                "&:hover": {
                                  backgroundColor: "rgba(28,56,145,0.08)",
                                },
                              }}
                            >
                              <EditRoundedIcon sx={{ fontSize: 17 }} />
                            </IconButton>
                          </Tooltip>
                        </Box>

                        {roleLabel && (
                          <Typography
                            noWrap
                            title={roleLabel}
                            sx={{
                              alignSelf: "flex-start",
                              maxWidth: "100%",
                              mt: "auto",
                              px: 1,
                              py: 0.3,
                              borderRadius: 1.5,
                              bgcolor: "#F5F6F9",
                              color: "#5A6272",
                              fontSize: 11,
                              fontWeight: 500,
                              letterSpacing: 0.2,
                            }}
                          >
                            {roleLabel}
                          </Typography>
                        )}
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 1.25,
                  py: { xs: 5, sm: 7 },
                  px: 2,
                  textAlign: "center",
                }}
              >
                <Box
                  sx={{
                    width: 52,
                    height: 52,
                    borderRadius: "50%",
                    bgcolor: "#F4F5F8",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <PeopleAltRoundedIcon
                    sx={{ fontSize: 24, color: "#A8AEBA" }}
                  />
                </Box>
                <Typography sx={{ fontSize: 14.5, color: "#5A6272" }}>
                  {staffStatusFilter === "active"
                    ? "No active users yet"
                    : "No inactive users"}
                </Typography>
                <Typography sx={{ fontSize: 12.5, color: "#9AA0AC" }}>
                  {staffStatusFilter === "active"
                    ? "Add someone from the Create User tab."
                    : "Everyone in this store is currently active."}
                </Typography>
              </Box>
            )}
          </Box>
        </>
      )}

      {activeTab === 1 && (
        <Box
          sx={{
            width: "100%",
            // A form field is only readable up to a point; past ~1200px the
            // inputs stop being fields and start being ribbons.
            maxWidth: 1200,
            mx: "auto",
            display: "flex",
            flexDirection: "column",
            gap: { xs: 1.75, sm: 2 },
            pb: 1,
          }}
        >
          {/* The <form> deliberately stops before the Yes/No manager: that
              component has submit-typed buttons of its own, and nesting it
              here made "Add question" save the user. The action bar reaches
              back into this form by id instead. */}
          <Box
            component="form"
            id="user-master-form"
            noValidate
            onSubmit={handleCreateOrUpdateUser}
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: { xs: 1.75, sm: 2 },
            }}
          >
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "minmax(0, 1fr)",
                  lg: "repeat(2, minmax(0, 1fr))",
                },
                gap: { xs: 1.75, sm: 2 },
                // Equal height, so the pair reads as two panels of one screen
                // rather than two blocks that happened to land side by side.
                alignItems: "stretch",
              }}
            >
              {/* ── Who they are ─────────────────────────────────────────── */}
              <SectionCard
                icon={
                  <PermIdentityRoundedIcon
                    sx={{ fontSize: 19, color: "#008080" }}
                  />
                }
                title="Personal details"
                hint="How the team reaches this person"
              >
                <Box sx={fieldRowSx}>
                  <TextField
                    required
                    fullWidth
                    label="Name"
                    placeholder="Full name"
                    autoComplete="name"
                    value={userData.userName || ""}
                    onChange={(e) => handleChange("userName", e.target.value)}
                    error={Boolean(fieldErrors.userName)}
                    helperText={fieldErrors.userName || ""}
                    ref={registerField("userName")}
                    sx={formStyle}
                  />

                  <TextField
                    required
                    fullWidth
                    type="tel"
                    label="Mobile"
                    placeholder="10-digit number"
                    value={userData.userMobile || ""}
                    onChange={(e) => {
                      const digitsOnly = e.target.value
                        .replace(/\D/g, "")
                        .slice(-10);
                      handleChange("userMobile", digitsOnly);
                    }}
                    onPaste={(e) => {
                      e.preventDefault();
                      let pasted = (
                        e.clipboardData || window.clipboardData
                      ).getData("text");

                      pasted = pasted.replace(/\D/g, "");

                      if (pasted.length > 10) {
                        pasted = pasted.slice(-10);
                      }

                      handleChange("userMobile", pasted);
                    }}
                    // No maxLength: it silently swallows keystrokes and fights
                    // soft keyboards that commit whole words. The keystroke
                    // guard refuses a non-digit outright and the onChange above
                    // is the backstop for anything pasted or autofilled.
                    inputProps={{
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                      autoComplete: "tel",
                      onKeyDown: (e) => {
                        if (e.ctrlKey || e.metaKey || e.altKey) return;
                        if (e.key.length > 1) return; // Backspace, Tab, arrows…
                        if (!/^[0-9]$/.test(e.key)) e.preventDefault();
                      },
                    }}
                    error={Boolean(fieldErrors.userMobile)}
                    helperText={fieldErrors.userMobile || ""}
                    ref={registerField("userMobile")}
                    sx={formStyle}
                  />
                </Box>

                <TextField
                  required
                  fullWidth
                  type="email"
                  label="E-mail"
                  placeholder="name@company.com"
                  value={userData.userEmail || ""}
                  onChange={(e) => handleChange("userEmail", e.target.value)}
                  inputProps={{ inputMode: "email", autoComplete: "email" }}
                  error={Boolean(fieldErrors.userEmail)}
                  helperText={fieldErrors.userEmail || ""}
                  ref={registerField("userEmail")}
                  sx={formStyle}
                />

                <TextField
                  fullWidth
                  multiline
                  minRows={2}
                  maxRows={5}
                  label="Address"
                  placeholder="Door no, street, city"
                  value={userData.userAddress || ""}
                  onChange={(e) => handleChange("userAddress", e.target.value)}
                  sx={formStyle}
                />
              </SectionCard>

              {/* ── What they can do ─────────────────────────────────────── */}
              <SectionCard
                icon={
                  <EngineeringRoundedIcon
                    sx={{ fontSize: 19, color: "#008080" }}
                  />
                }
                title="Role & access"
                hint="Where they sit and what they can reach"
              >
                {/* Stacked, not paired: this panel holds two fields against
                    the four next to it, and full-width dropdowns keep the two
                    cards looking like halves of the same thing. */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: { xs: 1.75, sm: 2 },
                  }}
                >
                  <FormControl
                    fullWidth
                    sx={formStyle}
                    required={editUserData !== null}
                    error={Boolean(fieldErrors.userDept)}
                    ref={registerField("userDept")}
                  >
                    <InputLabel id="user-dept-label">Department</InputLabel>
                    <Select
                      labelId="user-dept-label"
                      id="user-dept"
                      label="Department"
                      value={userData.userDept || ""}
                      onChange={(e) => handleChange("userDept", e.target.value)}
                      MenuProps={selectMenuProps}
                    >
                      {allDepartments?.map((dept) => (
                        <MenuItem key={dept.dept_id} value={dept.dept_id}>
                          {dept.dept_name}
                        </MenuItem>
                      ))}
                    </Select>
                    {fieldErrors.userDept && (
                      <FormHelperText>{fieldErrors.userDept}</FormHelperText>
                    )}
                  </FormControl>

                  <FormControl
                    fullWidth
                    required
                    sx={formStyle}
                    error={Boolean(fieldErrors.userRole)}
                    ref={registerField("userRole")}
                  >
                    <InputLabel id="user-role-label">Role</InputLabel>
                    <Select
                      labelId="user-role-label"
                      id="user-role"
                      label="Role"
                      // availableRoles is keyed by string, while an edited user
                      // arrives with a numeric role — without String() the
                      // dropdown has a value that matches no option and shows
                      // blank on every user you open.
                      value={
                        userData.userRole === null ||
                        userData.userRole === undefined ||
                        userData.userRole === ""
                          ? ""
                          : String(userData.userRole)
                      }
                      onChange={(e) => handleChange("userRole", e.target.value)}
                      MenuProps={selectMenuProps}
                    >
                      {Object.entries(availableRoles).map(([key, label]) => (
                        <MenuItem key={key} value={key}>
                          {label}
                        </MenuItem>
                      ))}
                    </Select>
                    {fieldErrors.userRole && (
                      <FormHelperText>{fieldErrors.userRole}</FormHelperText>
                    )}
                  </FormControl>
                </Box>

                {/* Branch — only for the two roles that are pinned to one.

                  A Store Head or a service role has branch_id NULL by design
                  (they are not confined to a place), so a picker for them would
                  be a field that changes nothing. Hidden too when the store has
                  a single branch: there is only one possible answer and the
                  server fills it in.

                  Blank on an existing user does NOT mean "the main branch" —
                  the payload omits the field entirely in that case, and the
                  server keeps whatever pin they already have. Sending an empty
                  value instead would quietly move every edited staff member to
                  the main branch. */}
                {isBranchPinned(userData.userRole) && branchList.length > 1 && (
                  <FormControl
                    fullWidth
                    sx={formStyle}
                    required={branchFieldRequired}
                    error={Boolean(fieldErrors.userBranch)}
                    ref={registerField("userBranch")}
                  >
                    <InputLabel id="user-branch-label">Branch</InputLabel>
                    <Select
                      labelId="user-branch-label"
                      id="user-branch"
                      label="Branch"
                      value={userData.userBranch ?? ""}
                      onChange={(e) =>
                        handleChange("userBranch", e.target.value)
                      }
                      MenuProps={selectMenuProps}
                    >
                      {branchList.map((branch) => (
                        <MenuItem key={branch.id} value={branch.id}>
                          {branch.name}
                          {branch.is_main ? " (Main)" : ""}
                        </MenuItem>
                      ))}
                    </Select>
                    {fieldErrors.userBranch ? (
                      <FormHelperText>{fieldErrors.userBranch}</FormHelperText>
                    ) : (
                      editUserData !== null &&
                      !userData.userBranch && (
                        <FormHelperText>
                          Leave blank to keep the branch they are already in.
                        </FormHelperText>
                      )
                    )}
                  </FormControl>
                )}

                {/* Status — an existing user can be switched off without being
                  deleted. Never offered while creating: a brand new user is
                  active by definition. */}
                {editUserData !== null && (
                  <Box>
                    <Typography
                      component="span"
                      id="user-status-label"
                      sx={{
                        display: "block",
                        fontSize: 12.5,
                        color: "#6B7280",
                        mb: 0.75,
                      }}
                    >
                      Status
                    </Typography>
                    <ToggleButtonGroup
                      exclusive
                      size="small"
                      aria-labelledby="user-status-label"
                      value={userData.userIsActive || "active"}
                      onChange={(e, newValue) => {
                        if (newValue)
                          setUserData((prev) => ({
                            ...prev,
                            userIsActive: newValue,
                          }));
                      }}
                      sx={segmentedTrackSx}
                    >
                      <ToggleButton value="active">
                        <Box
                          aria-hidden="true"
                          sx={{
                            width: 7,
                            height: 7,
                            borderRadius: "50%",
                            bgcolor: "#0B6B45",
                            mr: 0.75,
                          }}
                        />
                        Active
                      </ToggleButton>
                      <ToggleButton value="inactive">
                        <Box
                          aria-hidden="true"
                          sx={{
                            width: 7,
                            height: 7,
                            borderRadius: "50%",
                            bgcolor: "#B3261E",
                            mr: 0.75,
                          }}
                        />
                        Inactive
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </Box>
                )}
              </SectionCard>
            </Box>

            {/* ── Goals ────────────────────────────────────────────────────── */}
            <SectionCard
              icon={<GoalIcon width={17} height={19} />}
              title="Goals"
              hint="Targets that show up on this person's dashboard"
              collapsible
              expanded={goalsExpanded}
              onToggle={() => setGoalsExpanded((prev) => !prev)}
              action={
                <Button
                  type="button"
                  // Adding a goal to a folded card would add a row nobody can
                  // see, so the first click just opens it on the blank row.
                  onClick={() =>
                    goalsExpanded ? addGoalRow() : setGoalsExpanded(true)
                  }
                  startIcon={<AddRoundedIcon sx={{ fontSize: 18 }} />}
                  sx={{
                    flexShrink: 0,
                    // Full width on a phone: it is the only action in the card
                    // and a thumb-sized target beats a neat one.
                    width: { xs: "100%", sm: "auto" },
                    textTransform: "none",
                    fontSize: 13,
                    fontWeight: 500,
                    borderRadius: 2,
                    px: 1.5,
                    color: "#1c3891",
                    border: "1px solid #C9D3EA",
                    "&:hover": {
                      backgroundColor: "rgba(28,56,145,0.06)",
                      borderColor: "#1c3891",
                    },
                  }}
                >
                  Add goal
                </Button>
              }
            >
              {/* Column headings, wide screens only — on a phone each goal is a
                card of labelled-by-placeholder fields instead. */}
              <Box
                sx={{
                  display: { xs: "none", md: "grid" },
                  gridTemplateColumns: goalGridColumns,
                  gap: 1.25,
                  px: 0.25,
                  mb: -0.75,
                }}
              >
                {["Goal", "Target", "Type", "Division"].map((heading) => (
                  <Typography key={heading} sx={goalHeadingSx}>
                    {heading}
                  </Typography>
                ))}
                <Box />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: { xs: 1.5, md: 1.25 },
                }}
              >
                {goals?.map((goal, index) => (
                  <Box
                    key={index}
                    sx={{
                      border: { xs: "1px solid #F0F1F4", md: "none" },
                      borderRadius: { xs: 2.5, md: 0 },
                      p: { xs: 1.5, md: 0 },
                    }}
                  >
                    {/* Phone: name the row and give it its own remove button */}
                    <Box
                      sx={{
                        display: { xs: "flex", md: "none" },
                        alignItems: "center",
                        justifyContent: "space-between",
                        mb: 1.25,
                      }}
                    >
                      <Typography sx={goalHeadingSx}>
                        Goal {index + 1}
                      </Typography>
                      <IconButton
                        type="button"
                        size="small"
                        aria-label={`Remove goal ${index + 1}`}
                        onClick={() => removeGoalRow(index)}
                        sx={{ mr: -0.5 }}
                      >
                        <DeleteGoalIcon style={{ width: 16, height: 16 }} />
                      </IconButton>
                    </Box>

                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: {
                          xs: "minmax(0, 1fr)",
                          sm: "repeat(2, minmax(0, 1fr))",
                          md: goalGridColumns,
                        },
                        gap: { xs: 1.5, md: 1.25 },
                        alignItems: "start",
                      }}
                    >
                      <TextField
                        fullWidth
                        placeholder="Goal name"
                        value={goal.task_name || ""}
                        onChange={(e) =>
                          handleGoalFormChange(
                            index,
                            "task_name",
                            e.target.value
                          )
                        }
                        multiline
                        minRows={1}
                        maxRows={4}
                        sx={formStyle}
                      />

                      <TextField
                        fullWidth
                        type="number"
                        placeholder="Target"
                        value={goal.target ?? ""}
                        onChange={(e) =>
                          handleGoalFormChange(index, "target", e.target.value)
                        }
                        inputProps={{ min: 1, inputMode: "numeric" }}
                        sx={formStyle}
                      />

                      <TextField
                        select
                        fullWidth
                        value={goal.task_type || ""}
                        onChange={(e) =>
                          handleGoalFormChange(
                            index,
                            "task_type",
                            e.target.value
                          )
                        }
                        SelectProps={{
                          displayEmpty: true,
                          MenuProps: selectMenuProps,
                          renderValue: (selected) =>
                            selected || (
                              <Box component="span" sx={{ color: "#9CA3AF" }}>
                                Type
                              </Box>
                            ),
                        }}
                        sx={formStyle}
                      >
                        <MenuItem value="Daily">Daily</MenuItem>
                        <MenuItem value="Weekly">Weekly</MenuItem>
                        <MenuItem value="Sprint">Sprint</MenuItem>
                        <MenuItem value="Inactive">Inactive</MenuItem>
                      </TextField>

                      <Autocomplete
                        freeSolo
                        options={division.map((d) => ({
                          div_id: d.div_id,
                          div_name: d.div_name,
                        }))}
                        getOptionLabel={(option) => option.div_name || ""}
                        value={
                          goal.division
                            ? {
                                div_id: goal.division.div_id,
                                div_name: goal.division.div_name,
                              }
                            : null
                        }
                        onChange={(event, newValue) =>
                          handleGoalFormChange(index, "division", newValue)
                        }
                        onInputChange={(event, newInputValue) =>
                          handleGoalFormChange(index, "division", {
                            div_id: null,
                            div_name: newInputValue,
                          })
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Division"
                            fullWidth
                            sx={formStyle}
                          />
                        )}
                      />

                      <Tooltip title="Remove goal" arrow>
                        <IconButton
                          type="button"
                          aria-label={`Remove goal ${index + 1}`}
                          onClick={() => removeGoalRow(index)}
                          sx={{
                            display: { xs: "none", md: "inline-flex" },
                            alignSelf: "center",
                            width: 40,
                            height: 40,
                            borderRadius: 2,
                            border: "1px solid #EDEDF0",
                            "&:hover": {
                              borderColor: "#F0C4C4",
                              backgroundColor: "rgba(179,38,30,0.05)",
                            },
                          }}
                        >
                          <DeleteGoalIcon style={{ width: 16, height: 16 }} />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </Box>
                ))}
              </Box>
            </SectionCard>
          </Box>

          {/* Yes/No Questions Manager (only when editing an existing user).
              It carries its own card and header, so it is dropped straight
              into the flow rather than wrapped in another one. */}
          {editUserData && (
            <YesNoQuestionsManager
              user_id={editUserData.staff_id}
              store_id={store_id}
            />
          )}

          {/* ── Actions ──────────────────────────────────────────────────
              Sticky, because this form is taller than a phone screen and the
              save button used to be somewhere below the fold. App.js's main
              Box is the scroll container, which is what makes this stick. */}
          <Box
            sx={{
              position: "sticky",
              bottom: 0,
              zIndex: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              flexWrap: "wrap",
              gap: 1.25,
              mt: 0.5,
              px: { xs: 1.5, sm: 2 },
              py: 1.25,
              bgcolor: "rgba(255,255,255,0.92)",
              backdropFilter: "blur(6px)",
              border: "1px solid #EDEDF0",
              borderRadius: 3,
            }}
          >
            <Typography
              sx={{
                fontSize: 12,
                color: "#9AA0AC",
                mr: "auto",
                display: { xs: "none", sm: "block" },
              }}
            >
              Fields marked * are required
            </Typography>

            <Button
              type="button"
              onClick={handleClear}
              sx={{
                flexGrow: { xs: 1, sm: 0 },
                textTransform: "none",
                fontSize: 14,
                fontWeight: 500,
                borderRadius: 2,
                px: 2.5,
                py: 0.9,
                color: "#5A6272",
                border: "1px solid #E2E4EA",
                "&:hover": {
                  backgroundColor: "#F4F5F8",
                  borderColor: "#C9D3EA",
                },
              }}
            >
              Clear
            </Button>

            <Button
              type="submit"
              form="user-master-form"
              variant="contained"
              disableElevation
              sx={{
                flexGrow: { xs: 1, sm: 0 },
                textTransform: "none",
                fontSize: 14,
                fontWeight: 600,
                borderRadius: 2,
                px: 3,
                py: 0.9,
                bgcolor: "#1c3891",
                "&:hover": { bgcolor: "#17306F" },
              }}
            >
              {editUserData ? "Update user" : "Create user"}
            </Button>
          </Box>
        </Box>
      )}

      {/* Created/Edited User Custom Dialog Box */}
      {dialogConfig.open && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            position: "fixed",
            top: 0,
            left: 0,
            bgcolor: "rgba(0,0,0,0.5)",
            backdropFilter: "blur(8px)",
            zIndex: 999,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 0.5,
              px: 5,
              py: 2.5,
              bgcolor: "white",
              borderRadius: 5,
              width: "90%",
              maxWidth: 300,
              textAlign: "center",
            }}
          >
            {/* Icon */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "1px solid #fff",
                borderRadius: 100,
                boxShadow:
                  dialogConfig.type === "success"
                    ? "0px 0px 15px #D4F7D2"
                    : "0px 0px 15px #F7D2D2",
                p: 1,
                mb: 1.5,
              }}
            >
              {dialogConfig.type === "success" ? (
                <HowToRegRoundedIcon sx={{ fontSize: 42, fill: "#008046" }} />
              ) : (
                <CloseRoundedIcon sx={{ fontSize: 42, fill: "#FF474A" }} />
              )}
            </Box>

            {/* Message */}
            <Typography sx={{ textAlign: "center", wordWrap: "break-word" }}>
              {dialogConfig.message}
            </Typography>

            {/* Done Button */}
            <Typography
              sx={{
                bgcolor:
                  dialogConfig.type === "success"
                    ? theme.lightTheme.themeCol
                    : "#FF474A",
                color: "#fff",
                px: 2,
                py: 0.75,
                borderRadius: 3,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mt: 1,
                cursor: "pointer",
                textAlign: "center",
                width: "fit-content",
                minWidth: 80,
              }}
              onClick={() => {
                setDialogConfig((prev) => ({ ...prev, open: false }));
                if (dialogConfig.type === "success") {
                  setTimeout(() => navigate(-1), 300);
                }
              }}
            >
              Done
            </Typography>
          </Box>
        </Box>
      )}

      {/* Snackbar */}
      <Snackbar
        open={snackBarConfig.open}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        sx={{
          "&.MuiSnackbar-root": {
            bottom: "56px !important", // force override snackbar position
          },
        }}
      >
        {/* You can use Alert for styled messages */}
        <Alert
          onClose={handleClose}
          severity={snackBarConfig.severity}
          variant="filled"
        >
          {snackBarConfig.message}
        </Alert>
      </Snackbar>
    </>
  );
}

// The old version pinned the focused border and label to the same grey as the
// idle state, which left no way to see which field you were typing in. Focus
// now reads navy, error reads red, and both are visible at a glance.
const formStyle = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    bgcolor: "#fff",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#E2E4EA",
      borderRadius: "10px",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#C9D3EA" },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1c3891",
      borderWidth: "1.5px",
    },
    "&.Mui-error .MuiOutlinedInput-notchedOutline": { borderColor: "#D14343" },
  },
  "& .MuiOutlinedInput-input": { fontSize: 14.5, color: "#1A1D24" },
  "& .MuiInputLabel-root": { fontSize: 14, color: "#6B7280" },
  "& .MuiInputLabel-root.Mui-focused": { color: "#1c3891" },
  "& .MuiInputLabel-root.Mui-error": { color: "#D14343" },
  "& .MuiInputLabel-asterisk": { color: "#D14343" },
  "& .MuiFormHelperText-root": { fontSize: 11.5, marginLeft: "2px" },
};

export default UserMaster;
